import { RoutePermittedRole } from '@crema/constants/AppEnums';



import React from 'react';

const ChannelCommonInfo = React.lazy(() => import('../../modules/channelCommonInfo'));
const CommonInfoList = React.lazy(() => import('../../modules/channelCommonInfo/list'));
const CommonInfoRegistration = React.lazy(() => import('../../modules/channelCommonInfo/registration'));
const ProductTheme = React.lazy(() => import('../../modules/productTheme'));
const ThemeList = React.lazy(() => import('../../modules/productTheme/list'));
const ThemeRegistration = React.lazy(() => import('../../modules/productTheme/registration'));
const ChannelProduct = React.lazy(() => import('../../modules/productManagement'));

const BrandManagement = React.lazy(
  () => import('../../modules/brandManagement'),
);

const EditorDetail = React.lazy(
  () => import('../../modules/brandManagement/detail/EditorDetail'),
);

const InvoiceDetail = React.lazy(
  () => import('../../modules/brandManagement/detail/InvoiceDetail'),
);

const OrderDetail = React.lazy(
  () => import('../../modules/brandManagement/detail/OrderDetail'),
);

export const brandManagementConfigs = [
  {
    path: '/brand',
    element: <BrandManagement />,
  },

  {
    path: '/brand/editor',
    element: <EditorDetail />,
  },
  {
    path: '/brand/invoice',
    element: <InvoiceDetail />,
  },

  {
    path: '/brand/order',
    element: <OrderDetail />,
  },
];
